import React, { useCallback, useEffect, useState } from "react";
import { ChatCircleText } from "@phosphor-icons/react";
import api from "@/lib/api";
import { TestimonialItem } from "./TestimonialItem";

// Admin queue of buyer-submitted testimonials waiting for approval. Hidden when empty.
export function PendingTestimonials() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => {
    api.get("/testimonials", { params: { status: "pending" } })
      .then((r) => setItems(r.data?.items || []))
      .catch(() => setItems([]));
  }, []);
  useEffect(() => { load(); }, [load]);
  if (!items.length) return null;
  return (
    <section className="mx-4 mb-4 border-2 border-black bg-amber-50 p-3" data-testid="pending-testimonials">
      <div className="flex items-center gap-2 mb-2">
        <ChatCircleText size={16} weight="bold" />
        <h3 className="font-chivo font-black uppercase tracking-tight text-sm">Testimonials waiting for approval</h3>
        <span className="label-mono ml-auto" data-testid="pending-testimonials-count">{items.length}</span>
      </div>
      <div className="flex flex-col gap-2">
        {items.map((t) => <TestimonialItem key={t.id} t={t} admin showFirm onChanged={load} />)}
      </div>
    </section>
  );
}
